import { render, staticRenderFns } from "./DashAlerts.vue?vue&type=template&id=5857ed14"
import script from "./DashAlerts.vue?vue&type=script&lang=js"
export * from "./DashAlerts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports